// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__3np6r"};